import { constants } from '@/constants';

export const getConstant = (constantName: keyof typeof constants) =>
  constants[constantName];
